module.exports = __webpack_public_path__ + "img/2W.1646fcf4.jpg";